"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BanxStakingSettingsLayout = exports.RepaymentCallLayout = exports.LenderWeeklyLeaderboardLayout = exports.LenderLeaderboardLayout = exports.HadoMarketLayout = exports.HadespinRakebackLayout = exports.HadespinLeaderboardWeekEntryLayout = exports.HadespinLeaderboardEntryLayout = exports.RoundSettingsRawLayout = exports.UserRoundRawLayout = exports.RoundRawLayout = exports.BondTradeTransactionV2Layout = exports.FraktBondLayout = exports.BondOfferV2Layout = exports.WhitelistEntryLayout = exports.BondOfferValidationLayout = exports.BondingCurveRawLayout = void 0;
const buffer_layout_1 = require("@solana/buffer-layout");
const buffer_layout_utils_1 = require("@solana/buffer-layout-utils");
exports.BondingCurveRawLayout = (0, buffer_layout_1.struct)([(0, buffer_layout_utils_1.u64)('delta'), (0, buffer_layout_1.u8)('bondingType')]);
exports.BondOfferValidationLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.u64)('loanToValueFilter'),
    (0, buffer_layout_utils_1.u64)('durationFilter'),
    (0, buffer_layout_utils_1.u64)('maxReturnAmountFilter'),
    (0, buffer_layout_1.u32)('bondFeatures'),
]);
exports.WhitelistEntryLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.publicKey)('fraktMarket'),
    (0, buffer_layout_1.u8)('whitelistType'),
    (0, buffer_layout_utils_1.publicKey)('whitelistedAddress'),
]);
exports.BondOfferV2Layout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.publicKey)('hadoMarket'),
    (0, buffer_layout_1.u8)('pairState'),
    exports.BondingCurveRawLayout.replicate('bondingCurve'),
    (0, buffer_layout_utils_1.u64)('baseSpotPrice'),
    (0, buffer_layout_1.ns64)('mathCounter'),
    (0, buffer_layout_utils_1.u64)('currentSpotPrice'),
    (0, buffer_layout_utils_1.u64)('concentrationIndex'),
    (0, buffer_layout_utils_1.u64)('bidCap'),
    (0, buffer_layout_1.ns64)('bidSettlement'),
    (0, buffer_layout_utils_1.u64)('edgeSettlement'),
    (0, buffer_layout_utils_1.u64)('fundsSolOrTokenBalance'),
    (0, buffer_layout_utils_1.u64)('buyOrdersQuantity'),
    (0, buffer_layout_utils_1.u64)('lastTransactedAt'),
    (0, buffer_layout_utils_1.publicKey)('assetReceiver'),
    exports.BondOfferValidationLayout.replicate('validation'),
]);
exports.FraktBondLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)('fraktBondState'),
    (0, buffer_layout_1.u8)('bondTradeTransactionsCounter'),
    (0, buffer_layout_utils_1.u64)('borrowedAmount'),
    (0, buffer_layout_utils_1.publicKey)('banxStake'),
    (0, buffer_layout_utils_1.publicKey)('fraktMarket'),
    (0, buffer_layout_utils_1.u64)('amountToReturn'),
    (0, buffer_layout_utils_1.u64)('actualReturnedAmount'),
    (0, buffer_layout_1.u8)('terminatedCounter'),
    (0, buffer_layout_utils_1.publicKey)('fbondTokenMint'),
    (0, buffer_layout_utils_1.u64)('fbondTokenSupply'),
    (0, buffer_layout_utils_1.u64)('activatedAt'),
    (0, buffer_layout_utils_1.u64)('liquidatingAt'),
    (0, buffer_layout_utils_1.publicKey)('fbondIssuer'),
    (0, buffer_layout_utils_1.u64)('repaidOrLiquidatedAt'),
    (0, buffer_layout_utils_1.u64)('currentPerpetualBorrowed'),
    (0, buffer_layout_utils_1.u64)('lastTransactedAt'),
    (0, buffer_layout_utils_1.u64)('refinanceAuctionStartedAt'),
]);
exports.BondTradeTransactionV2Layout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)('bondTradeTransactionState'),
    (0, buffer_layout_utils_1.publicKey)('bondOffer'),
    (0, buffer_layout_utils_1.publicKey)('user'),
    (0, buffer_layout_utils_1.u64)('amountOfBonds'),
    (0, buffer_layout_utils_1.u64)('solAmount'),
    (0, buffer_layout_utils_1.u64)('feeAmount'),
    (0, buffer_layout_1.u8)('bondTradeTransactionType'),
    (0, buffer_layout_utils_1.publicKey)('fbondTokenMint'),
    (0, buffer_layout_utils_1.u64)('soldAt'),
    (0, buffer_layout_utils_1.u64)('redeemedAt'),
    (0, buffer_layout_1.u8)('redeemResult'),
    (0, buffer_layout_utils_1.publicKey)('seller'),
    (0, buffer_layout_utils_1.bool)('isDirectSell'),
]);
exports.RoundRawLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)("roundState"),
    (0, buffer_layout_utils_1.u64)("roundValue"),
    (0, buffer_layout_utils_1.u64)("startedAt"),
    (0, buffer_layout_utils_1.u64)("solAmount"),
    (0, buffer_layout_utils_1.u64)("feeAmount"),
    (0, buffer_layout_utils_1.u64)("participants"),
    (0, buffer_layout_utils_1.u64)("roundEndsAt"),
    (0, buffer_layout_utils_1.u64)("lastTransactedAt"),
    (0, buffer_layout_utils_1.publicKey)("winner"),
    (0, buffer_layout_utils_1.u64)("roundNumber"),
    (0, buffer_layout_utils_1.u64)("solInNftAmount"),
    (0, buffer_layout_utils_1.u64)("contractBid"),
    (0, buffer_layout_utils_1.u64)("placeholdeOne"),
    (0, buffer_layout_utils_1.u64)("placeholdeTwo"),
    (0, buffer_layout_utils_1.u64)("placeholdeThree"),
]);
exports.UserRoundRawLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.publicKey)("round"),
    (0, buffer_layout_utils_1.u64)("solDeposited"),
    (0, buffer_layout_utils_1.u64)("startSolPosition"),
    (0, buffer_layout_utils_1.publicKey)("user"),
    (0, buffer_layout_utils_1.u64)("lastTransactedAt"),
    (0, buffer_layout_utils_1.u64)("depositedAt"),
    (0, buffer_layout_utils_1.publicKey)("nftMint"),
    (0, buffer_layout_utils_1.u64)("jackpotSolAmount"),
    (0, buffer_layout_utils_1.u64)("jackpotClaimedAt"),
    (0, buffer_layout_utils_1.bool)("jackpotClaimed"),
    (0, buffer_layout_utils_1.u64)("placeholdeOne"),
    (0, buffer_layout_1.u32)("placeholdeTwo"),
    (0, buffer_layout_utils_1.bool)("placeholdeThree"),
    (0, buffer_layout_utils_1.bool)("placeholdeFour"),
    (0, buffer_layout_utils_1.bool)("placeholdeFive"),
]);
exports.RoundSettingsRawLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.u64)("completedRounds"),
    (0, buffer_layout_utils_1.u64)("totalSolDeposited"),
    (0, buffer_layout_utils_1.u64)("totalFeeCollected"),
    (0, buffer_layout_utils_1.u64)("totalParticipants"),
    (0, buffer_layout_utils_1.u64)("roundDuration"),
    (0, buffer_layout_utils_1.u64)("minSolToDeposit"),
    (0, buffer_layout_utils_1.u64)("feePercent"),
    (0, buffer_layout_utils_1.bool)("canInitializeNextRound"),
    (0, buffer_layout_utils_1.u64)("lastRoundEndsAt"),
    (0, buffer_layout_utils_1.u64)("lastTransactedAt"),
    (0, buffer_layout_utils_1.u64)("rakebackHadesForSol"),
    (0, buffer_layout_utils_1.u64)("contractBid"),
    (0, buffer_layout_utils_1.u64)("placeholdeOne"),
    (0, buffer_layout_utils_1.u64)("placeholdeTwo"),
]);
exports.HadespinLeaderboardEntryLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.publicKey)("user"),
    (0, buffer_layout_utils_1.u64)("totalSolDeposited"),
    (0, buffer_layout_utils_1.u64)("totalSolInNftDeposited"),
    (0, buffer_layout_utils_1.u64)("totalNftDeposited"),
    (0, buffer_layout_utils_1.u64)("totalFeePayed"),
    (0, buffer_layout_utils_1.u64)("totalSolWon"),
    (0, buffer_layout_utils_1.u64)("lastTransactedAt"),
    (0, buffer_layout_utils_1.publicKey)("placeholderOne"),
    (0, buffer_layout_utils_1.publicKey)("placeholderTwo"),
]);
exports.HadespinLeaderboardWeekEntryLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.publicKey)("user"),
    (0, buffer_layout_utils_1.u64)("week"),
    (0, buffer_layout_utils_1.u64)("totalSolDeposited"),
    (0, buffer_layout_utils_1.u64)("totalSolInNftDeposited"),
    (0, buffer_layout_utils_1.u64)("totalNftDeposited"),
    (0, buffer_layout_utils_1.u64)("totalFeePayed"),
    (0, buffer_layout_utils_1.u64)("totalSolWon"),
    (0, buffer_layout_utils_1.u64)("lastTransactedAt"),
    (0, buffer_layout_utils_1.publicKey)("placeholderOne"),
    (0, buffer_layout_utils_1.publicKey)("placeholderTwo"),
]);
exports.HadespinRakebackLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.publicKey)("user"),
    (0, buffer_layout_utils_1.u64)("hadesToClaimAmount"),
    (0, buffer_layout_utils_1.u64)("claimTimestamp"),
    (0, buffer_layout_utils_1.u64)("claimedAt"),
    (0, buffer_layout_utils_1.bool)("claimed"),
    (0, buffer_layout_utils_1.u64)("lastTransactedAt"),
    (0, buffer_layout_utils_1.publicKey)("placeholderOne"),
]);
;
exports.HadoMarketLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.publicKey)("marketAuthority"),
    (0, buffer_layout_1.u8)("marketState"),
    (0, buffer_layout_1.u8)("marketTrustType"),
    (0, buffer_layout_1.u8)("pairValidationType"),
    (0, buffer_layout_utils_1.publicKey)("fraktMarket"),
    (0, buffer_layout_utils_1.u64)("minBidCap"),
    (0, buffer_layout_utils_1.u64)("minMarketFee"),
    (0, buffer_layout_1.u8)("whitelistType"),
    (0, buffer_layout_utils_1.publicKey)("whitelistedAddress"),
]);
;
exports.LenderLeaderboardLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.publicKey)("user"),
    (0, buffer_layout_1.u8)("leaderboardState"),
    (0, buffer_layout_utils_1.u64)("lastClaimedAt"),
    (0, buffer_layout_utils_1.u64)("totalClaimedAmount"),
    (0, buffer_layout_utils_1.u64)("totalInterestRewards"),
    (0, buffer_layout_utils_1.u64)("totalLent"),
    (0, buffer_layout_utils_1.u64)("totalRepaid"),
    (0, buffer_layout_utils_1.u64)("placeholderOne"),
]);
;
exports.LenderWeeklyLeaderboardLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_utils_1.publicKey)("user"),
    (0, buffer_layout_1.u8)("leaderboardState"),
    (0, buffer_layout_utils_1.u64)("lastWeeklyClaimedAt"),
    (0, buffer_layout_utils_1.u64)("totalWeeklyClaimedAmount"),
    (0, buffer_layout_utils_1.u64)("week"),
    (0, buffer_layout_utils_1.u64)("totalInterestRewards"),
    (0, buffer_layout_utils_1.u64)("totalLent"),
    (0, buffer_layout_utils_1.u64)("totalRepaid"),
    (0, buffer_layout_utils_1.u64)("placeholderOne"),
]);
;
exports.RepaymentCallLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)("callState"),
    (0, buffer_layout_utils_1.publicKey)("user"),
    (0, buffer_layout_utils_1.publicKey)("bond"),
    (0, buffer_layout_utils_1.publicKey)("bondTradeTransaction"),
    (0, buffer_layout_utils_1.u64)("callAmount"),
    (0, buffer_layout_utils_1.u64)("lastUpdatedAt"),
    (0, buffer_layout_utils_1.u64)("lastCallAt"),
    (0, buffer_layout_utils_1.u64)("lastRepaidAt"),
    (0, buffer_layout_utils_1.publicKey)("placeholderOne"),
]);
;
exports.BanxStakingSettingsLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)("banxStakingSettingsState"),
    (0, buffer_layout_utils_1.u64)("maxTokenStakeAmount"),
    (0, buffer_layout_utils_1.u64)("tokensPerPartnerPoints"),
    (0, buffer_layout_utils_1.u64)("tokensStaked"),
    (0, buffer_layout_utils_1.u64)("banxStaked"),
    (0, buffer_layout_utils_1.u64)("tokensPerWeek"),
    (0, buffer_layout_utils_1.u64)("rewardsHarvested"),
    (0, buffer_layout_utils_1.publicKey)("placeholderOne"),
]);
